import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8fe383"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot is-justify-content-flex-end" }, null, -1))
const _hoisted_7 = { class: "modal-card-head" }
const _hoisted_8 = {
  key: 0,
  class: "is-flex is-flex-shrink-0"
}
const _hoisted_9 = { class: "icon has-text-white" }
const _hoisted_10 = {
  key: 1,
  class: "modal-card-title is-title-shrink"
}
const _hoisted_11 = {
  key: 2,
  class: "modal-card-title is-title-shrink"
}
const _hoisted_12 = { class: "modal-card-body" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "transaction-list-separator" }, null, -1))
const _hoisted_15 = { class: "frame3-sub-title mt-3 mb-3" }
const _hoisted_16 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "icon"
}
const _hoisted_19 = {
  key: 1,
  class: "icon"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecipientSelector = _resolveComponent("RecipientSelector")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_MoneyTransaction = _resolveComponent("MoneyTransaction")!
  const _component_TransactionItem = _resolveComponent("TransactionItem")!
  const _component_RecurrenceOptions = _resolveComponent("RecurrenceOptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$modal.step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Send money")) + " - 1/2 ", 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createVNode(_component_RecipientSelector, {
            currency: _ctx.selectedBackend,
            onClickRecipient: _ctx.handleClickRecipient
          }, null, 8, ["currency", "onClickRecipient"]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 2 && _ctx.selectedRecipient)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal-card",
          tabindex: "0",
          onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.isReady ? _ctx.sendTransaction() : null), ["enter"]))
        }, [
          _createElementVNode("header", _hoisted_7, [
            (!_ctx.transactionType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "mr-3 is-flex",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$modal.back()))
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_fa_icon, {
                        icon: "arrow-left",
                        class: "fa-lg"
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.transactionType === 'adminCredit')
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$gettext("Credit money")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.transactionType === "reconversion"
                ? _ctx.$gettext("Money reconversion")
                : _ctx.$gettext("Send money") + " - 2/2"), 1)),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_12, [
            _createVNode(_component_MoneyTransaction, {
              directionTransfer: "send",
              account: _ctx.ownSelectedAccount,
              selectedRecipient: _ctx.selectedRecipient,
              config: _ctx.config,
              parentErrors: _ctx.errors,
              transactionType: _ctx.transactionType,
              "onUpdate:amount": _cache[3] || (_cache[3] = (x) => ((_ctx.amount = x), _ctx.checkTransaction(true))),
              "onUpdate:senderMemo": _cache[4] || (_cache[4] = (x) => ((_ctx.senderMemo = x), _ctx.checkTransaction(x))),
              "onUpdate:recipientMemo": _cache[5] || (_cache[5] = 
              (x) => ((_ctx.recipientMemo = x), _ctx.checkTransaction(x))
            ),
              "onUpdate:isValid": _ctx.checkTransaction,
              onChange: _cache[6] || (_cache[6] = 
              (ev) => (ev ? null : ((_ctx.isReady = false), (_ctx.errors = false)))
            )
            }, null, 8, ["account", "selectedRecipient", "config", "parentErrors", "transactionType", "onUpdate:isValid"]),
            (_ctx.plannedTransactions.length > 1 && !_ctx.isRecurrenceEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("h2", _hoisted_15, _toDisplayString(this.$gettext(
                  "Payment will be done in %{nbTransactions} transactions:",
                  { nbTransactions: _ctx.plannedTransactions.length }
                )), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plannedTransactions, (transaction) => {
                    return (_openBlock(), _createBlock(_component_TransactionItem, {
                      key: transaction,
                      transaction: transaction,
                      mode: "small"
                    }, null, 8, ["transaction"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.transactionType !== 'reconversion' && _ctx.isRecurrentPaymentAllowed)
              ? (_openBlock(), _createBlock(_component_RecurrenceOptions, {
                  key: 1,
                  enabled: _ctx.isRecurrenceEnabled,
                  "onUpdate:enabled": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isRecurrenceEnabled) = $event)),
                  interval: _ctx.recurringInterval,
                  "onUpdate:interval": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.recurringInterval) = $event)),
                  ruleType: _ctx.recurringRuleType,
                  "onUpdate:ruleType": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.recurringRuleType) = $event)),
                  startDate: _ctx.dateStart,
                  "onUpdate:startDate": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dateStart) = $event)),
                  endDate: _ctx.dateEnd,
                  "onUpdate:endDate": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dateEnd) = $event)),
                  label: _ctx.$gettext('Set up a recurring payment')
                }, null, 8, ["enabled", "interval", "ruleType", "startDate", "endDate", "label"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("footer", _hoisted_16, [
            (!_ctx.isRecurrenceEnabled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button custom-button-modal has-text-weight-medium",
                  id: "send-money-button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendTransaction())),
                  disabled: !_ctx.isReady || _ctx.checkOngoing > 0
                }, [
                  (_ctx.checkOngoing > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createVNode(_component_fa_icon, {
                          icon: "circle-notch",
                          class: "fa-lg refreshing"
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, [
                        _createVNode(_component_fa_icon, {
                          icon: "arrow-circle-up",
                          class: "fa-lg"
                        })
                      ])),
                  _createElementVNode("span", null, _toDisplayString(_ctx.transactionType === "reconversion"
                  ? _ctx.$gettext("Reconversion")
                  : _ctx.$gettext("Send")), 1)
                ], 8, _hoisted_17))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button custom-button-modal has-text-weight-medium",
                  id: "create-recurrence-button",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openCreateRecurrenceModal())),
                  disabled: !_ctx.isRecurrenceReady
                }, [
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_fa_icon, {
                      icon: "sync",
                      class: "fa-lg"
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Create recurrence contract")), 1)
                ], 8, _hoisted_20))
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}